<template>
  <div class="base-pagination">
    <el-pagination :page-size.sync="pageSize" :current-page.sync="currentPage" @current-change="currentChange"
                   :pager-count="5" :background="background" layout="prev, pager, next, slot" :total="total">
      <div class="base-pagination-box">
        查询到 {{ total }} 条记录，共 {{ pageTotal }} 页
      </div>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    background: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 18,
    },
    parentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  created() {
    this.currentPage = this.parentPage
  },
  computed: {
    pageTotal() {
      return parseInt((this.total + this.pageSize - 1) / this.pageSize)
    },
  },
  methods: {
    currentChange() {
      this.$emit('currentChange', this.currentPage)
    },
  },
  watch: {
    parentPage(newVal) {
      this.currentPage = newVal
    },
  },
}
</script>

<style lang="less">
.base-pagination {
  display: inline-block;
  width: 100%;
  text-align: center;
  padding: 12px 20px;
  line-height: 26px;


  .el-pagination {
    padding: 0 !important;

    button {
      height: 26px !important;
      line-height: 26px !important;
    }
  }

  .el-pager li {
    padding: 0;
    font-size: 12px;
    font-weight: 400;
    min-width: 26px;
    height: 26px;
    line-height: 26px;
  }

  .el-pager .more::before {
    line-height: 26px;
  }

  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    border: 1px solid #d9d9d9;
    background-color: #FFFFFF;
    margin: 0 6px;
    color: #202937;
    min-width: 26px;
    border-radius: 4px;
  }


  .el-pagination.is-background .el-pager li:not(.disabled).active {
    border: unset;
    background: #4a75f5;
  }

  .el-pagination button:disabled {
    color: #D9D9D9 !important;
  }

  &-box {
    display: inline-block;
    margin-left: 12px;
    font-size: 14px;
    line-height: 26px;
    font-weight: 400;
    color: #3A485E;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
  }
}
</style>
